import component from './packet-card.component';

export default angular
  .module('fizyweb.paycell.noauth.packetcard', [])
  .component('fizyPaycellNoAuthPacketCard', component).name;



// WEBPACK FOOTER //
// src/app/no-auth/components/packet-card/packet-card.module.ts